import gql from 'graphql-tag';

export const QUERY = gql([
    `
query findVoyageLandingContent($id: String!) {
  findVoyageLandingContent(id: $id) {
    data {
      pageTitle {
        iv
      }
      seoDescription {
        iv
      }
      seoKeywords {
        iv
      }
      seoThumbnail {
        iv {
          url
        }
      }
      carouselFilterTitle {
        iv
      }
      carouselFilterTextColor {
        iv
      }
      destinations {
        iv {
          title
          subTitle
          color
          link
          picture {
            url
            fileSize
          }
          textColor
          justification
          month
        }
      }
      color1 {
        iv
      }
      color2 {
        iv
      }
      cta2Link {
        iv
      }
      cta2Text {
        iv
      }
      cta2Style {
        iv
      }
      ctaLink {
        iv
      }
      ctaText {
        iv
      }
      ctaStyle {
        iv
      }
      ctaText2 {
        iv
      }
      ctaLink2 {
        iv
      }
      ctaStyle2 {
        iv
      }
      ctaText22 {
        iv
      }
      ctaLink22 {
        iv
      }
      ctaStyle22 {
        iv
      }
      ctaLink1 {
        iv
      }
      ctaText1 {
        iv
      }
      ctaStyle1 {
        iv
      }
      ctaLink12 {
        iv
      }
      ctaText12 {
        iv
      }
      ctaStyle12 {
        iv
      }
      width1 {
        iv
      }
      width2 {
        iv
      }
      tagline1 {
        iv
      }
      tagline2 {
        iv
      }
      horizontalPosition1 {
        iv
      }
      horizontalPosition2 {
        iv
      }
      justification1 {
        iv
      }
      justification2 {
        iv
      }
      labelFontSizeTitle {
        iv
      }
      labelTitle {
        iv
      }
      labelTitleColor {
        iv
      }
      picture1 {
        iv {
          url
          fileSize
        }
      }
      picture2 {
        iv {
          url
          fileSize
        }
      }
      ribbonColor {
        iv
      }
      ribbonList {
        iv {
          picture {
            url
            fileSize
          }
          title
          subTitle
        }
      }
      ribbonTitle {
        iv
      }
      ribbonPicture {
        iv {
          url
          fileSize
        }
      }
      subTitle2 {
        iv
      }
      subtitle1 {
        iv
      }
      fontSizeSubTitle1 {
        iv
      }
      fontSizeSubTitle2 {
        iv
      }
      textColor1 {
        iv
      }
      textColor2 {
        iv
      }
      title1 {
        iv
      }
      fontSizeTitle1 {
        iv
      }
      title2 {
        iv
      }
      fontSizeTitle2 {
        iv
      }
      customerColor {
        iv
      }
      customerTitle {
        iv
      }
      customerLink {
        iv
      }
      customerItems {
        iv {
          title
          subTitle
          picture {
            url
            fileSize
          }
        }
      }
      mentions {
        iv
      }
    }
  }
}
`,
]);
